<div class="modal-container">
  <button
    id="modalPolitica"
    #modalPolitica
    data-bs-toggle="modal"
    data-bs-target="#modalAlerta1"
    hidden="hidden"
    hidden
  aria-hidden="true"
  tabindex="-1">
    Launch
  </button>
  <div
    class="modal fade"
    id="modalAlerta1"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    tabindex="-1"
    aria-labelledby="modalTitle"
    aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-scrollable">
      <div class="modal-content modal-content-govco">
        <div class="modal-header modal-header-govco modal-header-alerts-govco">
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            (click)="cancelar()"></button>
        </div>
        <div class="modal-body modal-body-govco center-elements-govco">
          <div class="modal-icon">
            <span class="modal-icon-govco modal-confirmation-icon"></span>
          </div>
          <h3 class="modal-title-govco" id="modalTitle">
            {{"modal-politicas.consentimiento" | translate}}
          </h3>
          <div class="modal-text-govco modal-text-center-govco px-2">
            <h4 class="h4-tipografia-govco">{{"modal-politicas.principios" | translate}}</h4>
            <p>
              {{"modal-politicas.intro" | translate}}
            </p>
            <ul class="alpha-list">
              <li>
                {{"modal-politicas.legalidad" | translate}}
              </li>
              <li>
                {{"modal-politicas.finalidad" | translate}}
              </li>
              <li>
                {{"modal-politicas.libertad" | translate}}
              </li>
              <li>
                {{"modal-politicas.veracidad" | translate}}
              </li>
              <li>
                {{"modal-politicas.transparencia" | translate}}
              </li>
              <li>
                {{"modal-politicas.acceso" | translate}}
              </li>
              <li>
                {{"modal-politicas.seguridad" | translate}}
              </li>
              <li>
                {{"modal-politicas.confidencialidad" | translate}}
              </li>
            </ul>
            <h4 class="h4-tipografia-govco">
              {{"modal-politicas.tratamiento" | translate}}
            </h4>
            <p>
              {{"modal-politicas.tratamiento-datos" | translate}}
            </p>
            <ul class="alpha-list">
              <li>
                {{"modal-politicas.finalidades.desarrollo-objeto" | translate}}
              </li>
              <li>
                {{"modal-politicas.finalidades.registro-ingreso" | translate}}
              </li>
              <li>
                {{"modal-politicas.finalidades.contratacion" | translate}}
              </li>
              <li>
                {{"modal-politicas.finalidades.seleccion-personal" | translate}}
              </li>
              <li>
                {{"modal-politicas.finalidades.salud-ocupacional" | translate}}
              </li>
              <li>
                {{"modal-politicas.finalidades.historia-laboral" | translate}}
              </li>
              <li>
                {{"modal-politicas.finalidades.gestion-peticiones" | translate}}
              </li>
              <li>
                {{"modal-politicas.finalidades.analisis-seguridad" | translate}}
              </li>
              <li>
                {{"modal-politicas.finalidades.video-vigilancia" | translate}}
              </li>
              <li>
                {{"modal-politicas.finalidades.conservar-evidencia" | translate}}
              </li>
              <li>
                {{"modal-politicas.finalidades.requerimientos-entes" | translate}}
              </li>
              <li>
                {{"modal-politicas.finalidades.rendicion-cuentas" | translate}}
              </li>
              <li>
                {{"modal-politicas.finalidades.satisfaccion-usuarios" | translate}}
              </li>
              <li>
                {{"modal-politicas.finalidades.registro-datos" | translate}}
              </li>
            </ul>
            <p>
              {{"modal-politicas.asi_mismo" | translate}}
              <br />
              {{"modal-politicas.de_acuerdo" | translate}}
            </p>
            <ul class="alpha-list">
              <li>{{"modal-politicas.finalidades_adicionales.cumplimiento_mision" | translate}}</li>
              <li>
                {{"modal-politicas.finalidades_adicionales.envio_informacion" | translate}}
              </li>
              <li>
                {{"modal-politicas.finalidades_adicionales.estado_solicitudes" | translate}}
              </li>
              <li>{{"modal-politicas.finalidades_adicionales.gestion_peticiones" | translate}}</li>
              <li>
                {{"modal-politicas.finalidades_adicionales.encuestas_satisfaccion" | translate}}
              </li>
              <li>
                {{"modal-politicas.finalidades_adicionales.atencion_requerimientos" | translate}}
              </li>
              <li>
                {{"modal-politicas.finalidades_adicionales.respuestas_y_eventos" | translate}}
              </li>
              <li>
                {{"modal-politicas.finalidades_adicionales.contacto_titular" | translate}}
              </li>
            </ul>
            <h4 class="h4-tipografia-govco">
              {{"modal-politicas.derechos_titular_titulo" | translate}}
            </h4>
            <p>
              {{"modal-politicas.requiere" | translate}}
              <br />
              <strong>{{"modal-politicas.requiere_datos" | translate}}</strong>
              {{"modal-politicas.requiere_datos_parrafo" | translate}}
            </p>
            <ul class="alpha-list">
              <li>
                {{"modal-politicas.derechos_titular.0" | translate}}
              </li>
              <li>
                {{"modal-politicas.derechos_titular.1" | translate}}
              </li>
              <li>
                {{"modal-politicas.derechos_titular.2" | translate}}
              </li>
              <li>
                {{"modal-politicas.derechos_titular.3" | translate}}
              </li>
              <li>
                {{"modal-politicas.derechos_titular.4" | translate}}
              </li>
              <li>
                {{"modal-politicas.derechos_titular.5" | translate}}
              </li>
            </ul>
            <p>
              {{"modal-politicas.autorizacion" | translate}}
            </p>
            <h4 class="h4-tipografia-govco">
              {{"modal-politicas.deberes_titulo" | translate}}
            </h4>
            <p>
              {{"modal-politicas.introduccion_deberes" | translate}}
            </p>
            <ul class="alpha-list">
              <li>
                {{"modal-politicas.deberes.0" | translate}}
              </li>
              <li>
                {{"modal-politicas.deberes.1" | translate}}
              </li>
              <li>
                {{"modal-politicas.deberes.2" | translate}}
                <ul class="alpha-list">
                  <li>
                    {{"modal-politicas.deberes.3.detalle" | translate}}
                  </li>
                </ul>
              </li>
              <li>
                {{"modal-politicas.deberes.4" | translate}}
              </li>
              <li>
                {{"modal-politicas.deberes.5" | translate}}
              </li>
              <li>
                {{"modal-politicas.deberes.6" | translate}}
              </li>
              <li>
                {{"modal-politicas.deberes.7" | translate}}
              </li>
              <li>
                {{"modal-politicas.deberes.8" | translate}}
              </li>
              <li>
                {{"modal-politicas.deberes.9" | translate}}
              </li>
              <li>
                {{"modal-politicas.deberes.10" | translate}}
              </li>
              <li>
                {{"modal-politicas.deberes.11" | translate}}
              </li>
              <li>
                {{"modal-politicas.deberes.12" | translate}}
              </li>
              <li>
                {{"modal-politicas.deberes.13" | translate}}
              </li>
              <li>
                {{"modal-politicas.deberes.14" | translate}}
              </li>
              <li>
                {{"modal-politicas.deberes.15" | translate}}
              </li>
            </ul>
            <h4 class="h4-tipografia-govco">{{"modal-politicas.directrices_generales.titulo" | translate}}</h4>
            <p>
              <strong>{{"modal-politicas.directrices_generales.numeral_uno" | translate}}</strong> {{"modal-politicas.directrices_generales.parrafo_uno" | translate}}
              <br />
              <strong>{{"modal-politicas.directrices_generales.numeral_dos" | translate}}</strong>
              {{"modal-politicas.directrices_generales.parrafo_dos" | translate}}
              <br />
              <strong>{{"modal-politicas.directrices_generales.numeral_tres" | translate}}</strong> 
              {{"modal-politicas.directrices_generales.parrafo_tres" | translate}}
              <br />
              {{"modal-politicas.directrices_generales.parrafo_tres_bis" | translate}}
            </p>
            <ul>
              <li>
                {{"modal-politicas.directrices_generales.lista_politicas.0" | translate}}
              </li>
              <li>
                {{"modal-politicas.directrices_generales.lista_politicas.1" | translate}}
              </li>
              <li>
                {{"modal-politicas.directrices_generales.lista_politicas.2" | translate}}
              </li>
              <li>
                {{"modal-politicas.directrices_generales.lista_politicas.3" | translate}}
              </li>
              <li>
                {{"modal-politicas.directrices_generales.lista_politicas.4" | translate}}
              </li>
              <li>
                {{"modal-politicas.directrices_generales.lista_politicas.5" | translate}}
              </li>
              <li>
                {{"modal-politicas.directrices_generales.lista_politicas.6" | translate}}
              </li>
              <li>
                {{"modal-politicas.directrices_generales.lista_politicas.7" | translate}}
              </li>
              <li>
                {{"modal-politicas.directrices_generales.lista_politicas.8" | translate}}
              </li>
              <li>
                {{"modal-politicas.directrices_generales.lista_politicas.9" | translate}}
              </li>
              <li>
                {{"modal-politicas.directrices_generales.lista_politicas.10" | translate}}
              </li>
              <li>
                {{"modal-politicas.directrices_generales.lista_politicas.11" | translate}}
              </li>
              <li>
                {{"modal-politicas.directrices_generales.lista_politicas.12" | translate}}
              </li>
              <li>
                {{"modal-politicas.directrices_generales.lista_politicas.13" | translate}}
              </li>
              <li>
                {{"modal-politicas.directrices_generales.lista_politicas.14" | translate}}
              </li>
              <li>
                {{"modal-politicas.directrices_generales.lista_politicas.15" | translate}}
              </li>
              <li>
                {{"modal-politicas.directrices_generales.lista_politicas.16" | translate}}
              </li>
              <li>
                {{"modal-politicas.directrices_generales.lista_politicas.17" | translate}}
              </li>
              <li>
                {{"modal-politicas.directrices_generales.lista_politicas.18" | translate}}
              </li>
              <li>
                {{"modal-politicas.directrices_generales.lista_politicas.19" | translate}}
              </li>
              <li>
                {{"modal-politicas.directrices_generales.lista_politicas.20" | translate}}
              </li>
              <li>
                {{"modal-politicas.directrices_generales.lista_politicas.21" | translate}}
              </li>
              <li>
                {{"modal-politicas.directrices_generales.lista_politicas.22" | translate}}
              </li>
              <li>
                {{"modal-politicas.directrices_generales.lista_politicas.23" | translate}}
              </li>
              <li>
                {{"modal-politicas.directrices_generales.lista_politicas.24" | translate}}
              </li>
              <li>
                {{"modal-politicas.directrices_generales.lista_politicas.25" | translate}}
              </li>
              <li>
                {{"modal-politicas.directrices_generales.lista_politicas.26" | translate}}
              </li>
              <li>
                {{"modal-politicas.directrices_generales.lista_politicas.27" | translate}}
              </li>
              <li>
                {{"modal-politicas.directrices_generales.lista_politicas.28" | translate}}
              </li>
              <li>
                {{"modal-politicas.directrices_generales.lista_politicas.29" | translate}}
              </li>
              <li>
                {{"modal-politicas.directrices_generales.lista_politicas.30" | translate}}
              </li>
              <li>
                {{"modal-politicas.directrices_generales.lista_politicas.31" | translate}}
              </li>
            </ul>
            <br />
            <p>
              {{"modal-politicas.directrices_generales.parrafo_documentos" | translate}}
              <br />
              <strong>{{"modal-politicas.directrices_generales.numeral_cuatro" | translate}}</strong> {{"modal-politicas.directrices_generales.parrafo_cuatro" | translate}}
            </p>
            <ul>
              <li>
                {{"modal-politicas.directrices_generales.lista_deberes_funcionarios.0" | translate}}
              </li>
              <li>
                {{"modal-politicas.directrices_generales.lista_deberes_funcionarios.1" | translate}}
              </li>
              <li>
                {{"modal-politicas.directrices_generales.lista_deberes_funcionarios.2" | translate}}
              </li>
              <li>
                {{"modal-politicas.directrices_generales.lista_deberes_funcionarios.3" | translate}}
              </li>
              <li>
                {{"modal-politicas.directrices_generales.lista_deberes_funcionarios.4" | translate}}
              </li>
              <li>
                {{"modal-politicas.directrices_generales.lista_deberes_funcionarios.5" | translate}}
              </li>
              <li>
                {{"modal-politicas.directrices_generales.lista_deberes_funcionarios.6" | translate}}
              </li>
              <li>
                {{"modal-politicas.directrices_generales.lista_deberes_funcionarios.7" | translate}}
              </li>
              <li>
                {{"modal-politicas.directrices_generales.lista_deberes_funcionarios.8" | translate}}
              </li>
              <li>
                {{"modal-politicas.directrices_generales.lista_deberes_funcionarios.9" | translate}}
              </li>
              <li>
                {{"modal-politicas.directrices_generales.lista_deberes_funcionarios.10" | translate}}
              </li>
              <li>
                {{"modal-politicas.directrices_generales.lista_deberes_funcionarios.11" | translate}}
              </li>
            </ul>
            <p>
              <strong>{{"modal-politicas.directrices_generales.numeral_quinto" | translate}}</strong> {{"modal-politicas.directrices_generales.parrafo_quinto" | translate}}
            </p>
            <ul>
              <li>
                {{"modal-politicas.directrices_generales.lista_tener_presente.0" | translate}}
              </li>
              <li>
                {{"modal-politicas.directrices_generales.lista_tener_presente.1" | translate}}
              </li>
            </ul>
            <p>
              {{"modal-politicas.directrices_generales.parrafo_quinto_bis" | translate}}
            </p>
            <br />
            <p>

              <strong>{{"modal-politicas.directrices_generales.numeral_sexto" | translate}}</strong>
              <br />
              {{"modal-politicas.directrices_generales.parrafo_sexto" | translate}}
            </p>
            <ul>
              <li>
                {{"modal-politicas.directrices_generales.lista_deberes_proveedor_servicios.0" | translate}}
              </li>
              <li>
                {{"modal-politicas.directrices_generales.lista_deberes_proveedor_servicios.1" | translate}}
              </li>
              <li>
                {{"modal-politicas.directrices_generales.lista_deberes_proveedor_servicios.2" | translate}}
              </li>
            </ul>
            <h4 class="h4-tipografia-govco">
              {{"modal-politicas.responsabilidades.titulo" | translate}}
            </h4>
            <p>
              {{"modal-politicas.responsabilidades.parrafo" | translate}}
            </p>
            <ul class="alpha-list">
              <li>
                {{"modal-politicas.responsabilidades.lista_politicas.0" | translate}}
              </li>
              <li>
                {{"modal-politicas.responsabilidades.lista_politicas.1" | translate}}
              </li>
              <li>
                {{"modal-politicas.responsabilidades.lista_politicas.2" | translate}}
              </li>
            </ul>
            <br />
            <p>
              {{"modal-politicas.responsabilidades.parrafo_dos" | translate}}
            </p>
            <br />
            <p>
              {{"modal-politicas.responsabilidades.parrafo_tres" | translate}}
              <br />
              {{"modal-politicas.responsabilidades.parrafo_cuatro" | translate}}
              <a
                href="https://www.minjusticia.gov.co/Servicio-al-Ciudadano/Politica-Proteccion-Datos-Personales"
                target="_blank"
                rel="noopener noreferrer"
                title="Servicio al ciudadano"
                >https://www.minjusticia.gov.co/Servicio-al-Ciudadano/Politica-Proteccion-Datos-Personales</a
              >
              {{"modal-politicas.responsabilidades.parrafo_cinco" | translate}}
            </p>
            <h4 class="h4-tipografia-govco">
              {{"modal-politicas.procedimientos.titulo" | translate}}
            </h4>
            <p>
              {{"modal-politicas.procedimientos.parrafo" | translate}}
            </p>
            <ul class="alpha-list">
              <li>
                {{"modal-politicas.procedimientos.ventanilla" | translate}}
              </li>
            </ul>
            <p>
              {{"modal-politicas.procedimientos.parrafo_dos" | translate}}
            </p>
            <ul>
              <li>
                {{"modal-politicas.procedimientos.lista_informacion.0" | translate}}
              </li>
              <li>
                {{"modal-politicas.procedimientos.lista_informacion.1" | translate}}
              </li>
              <li>{{"modal-politicas.procedimientos.lista_informacion.2" | translate}}</li>
              <li>
                {{"modal-politicas.procedimientos.lista_informacion.3" | translate}}
              </li>
              <li>{{"modal-politicas.procedimientos.lista_informacion.4" | translate}}</li>
            </ul>
            <p>
              <strong>{{"modal-politicas.procedimientos.parrafo_tres" | translate}}</strong>
              {{"modal-politicas.procedimientos.parrafo_tres_bis" | translate}}
            </p>
            <ul class="alpha-list">
              <li>{{"modal-politicas.procedimientos.lista.0" | translate}}</li>
              <li>
                {{"modal-politicas.procedimientos.lista.1" | translate}}
              </li>
              <li>{{"modal-politicas.procedimientos.lista.2" | translate}}</li>
              <li>{{"modal-politicas.procedimientos.lista.3" | translate}}</li>
              <li>
                {{"modal-politicas.procedimientos.lista.4" | translate}}
              </li>
              <li>
                {{"modal-politicas.procedimientos.lista.5" | translate}}
              </li>
            </ul>
            <p>
              {{"modal-politicas.procedimientos.parrafo_cuatro" | translate}}
              <br />
              {{"modal-politicas.procedimientos.parrafo_cinco" | translate}}
            </p>
            <h4 class="h4-tipografia-govco">{{"modal-politicas.sansiones.titulo" | translate}}</h4>
            <p>
              {{"modal-politicas.sansiones.parrafo" | translate}}
            </p>
            <h4 class="h4-tipografia-govco">{{"modal-politicas.vigencias.titulo" | translate}}</h4>
            <p>
              {{"modal-politicas.vigencias.parrafo" | translate}}
              <br />
              <a
                href="https://www.minjusticia.gov.co/Servicio-al-Ciudadano/Politica-Proteccion-Datos-Personales"
                target="_blank"
                rel="noopener noreferrer"
                title="Servicio al ciudadano"
                >https://www.minjusticia.gov.co/Servicio-al-Ciudadano/Politica-Proteccion-Datos-Personales</a
              >
              {{"modal-politicas.vigencias.parrafo_dos" | translate}}
            </p>
            <h4 class="h4-tipografia-govco">
              {{"modal-politicas.periodo_vigencia.titulo" | translate}}
            </h4>
            <p>
              {{"modal-politicas.periodo_vigencia.parrafo" | translate}}
            </p>
          </div>
        </div>
        <div class="modal-footer-govco modal-footer-alerts-govco">
          <div class="modal-buttons-govco justify-content-evenly mt-1">
            <button
              type="button"
              class="btn btn-primary btn-modal-govco"
              data-bs-dismiss="modal"
              (click)="abrirModalPersona()"
              aria-label="Aceptar">
              {{"modal-politicas.aceptar" | translate}}
            </button>
            <!-- <button
              type="button"
              class="btn btn-primary btn-modal-govco"
              data-bs-dismiss="modal"
              (click)="abrirModalAbogado()"
              *ngIf="isAbogado">
              {{"modal-politicas.aceptar" | translate}}
            </button> -->
            <button
              type="button"
              class="btn btn-primary btn-modal-govco btn-contorno"
              data-bs-dismiss="modal"
              (click)="cancelar()"
              aria-label="Cancelar">
              {{"modal-politicas.cancelar" | translate}}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div *ngIf="openModalPersona">
  <app-modal-datos-adicionales [openConfigCuenta]="false"></app-modal-datos-adicionales>
</div>
<!-- <div *ngIf="isAbogado && openModalAbogado">
  <app-modal-datos-adicionales-abogado></app-modal-datos-adicionales-abogado>
</div> -->
